import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '*',
      redirect: '/'
    }, {
      path: '/',
      name: 'PageView',
      component: resolve => require(['@/view/PageView'], resolve),
      children: [
        {
          path: '/',
          redirect: '/home'
        }, {
          path: '/home',
          name: 'home',
          component:() => import('@/view/HomePage'),
          meta: {
            title: '阳光采购平台'
          }
        }, {
          path: '/newsinformation',
          name: 'newsinformation',
          component:() => import('@/view/NewsInformation'),
          meta: {
            title: '新闻动态'
          }
        }, {
          path: '/ggdetail',
          name: 'ggdetail',
          component:() => import('@/view/GGDetail'),
          meta: {
            title: '公告详情'
          },
        },
        {
          path: '/news',
          name: 'news',
          component:() => import('@/view/News'),
          meta: {
            title: '通知公告'
          }
        },
        {
          path: '/newsdetails',
          name: 'newsdetails',
          component:() => import('@/view/Newsdetails'),
          meta: {
            title: '通知公告'
          }
        },
        {
          path: '/boffing',
          name: 'boffing',
          component:() => import('@/view/Boffing'),
          meta: {
            title: '招标采购'
          }
        },
        {
          path: '/noboffing',
          name: 'noboffing',
          component:() => import('@/view/NoBoffing'),
          meta: {
            title: '非招标采购'
          }
        },
        {
          path: '/njsinfo',
          name: 'njsinfo',
          component:() => import('@/view/NJSInfo'),
          meta: {
            title: '农交所'
          }
        },
        {
          path: '/helpcenter',
          name: 'helpcenter',
          component:() => import('@/view/HelpCenter'),
          meta: {
            title: '帮助中心'
          }
        },
        {
          path: '/helpcenter/helpsdetails',
          name: 'helpsdetails',
          component:() => import('@/view/Helpsdetails'),
        },
        {
          path:'/policieslaw',
          name:'policieslaw',
          component:() => import('@/view/PoliciesLaw'),
          children:[
            {
                path: '/policieslaw/nationalpolicy',
                name: 'nationalpolicy',
                component:() => import('@/view/NationalPolicy'),
                meta: {
                  title: '国家相关政策'
                }
              }, {
                path: '/policieslaw/localpolicy',
                name: 'localpolicy',
                component:() => import('@/view/LocalPolicy'),
                meta: {
                  title: '地方相关政策'
                }
              },
              {
                path: '/policieslaw/platformpolicy',
                name: 'platformpolicy',
                component:() => import('@/view/PlatformPolicy'),
                meta: {
                  title: '平台政策'
                }
              },
          ]
        },

        {
          path: '/operationprocedure',
          name: 'operationprocedure',
          component:() => import('@/view/OperationProcedure'),
          meta: {
            title: '操作手册'
          }
        },
        {
          path: '/relateddownload',
          name: 'relateddownload',
          component:() => import('@/view/RelatedDownload'),
          meta: {
            title: '相关操作'
          }
        },
        {
          path: '/frequencyquestion',
          name: 'frequencyquestion',
          component:() => import('@/view/FrequencyQuestion'),
          meta: {
            title: '常见问题'
          }
        },  {
          path: '/relateddownload',
          name: 'relateddownload',
          component:() => import('@/view/RelatedDownload'),
          meta: {
            title: '相关操作'
          }
        },{
          path: '/platformintroduction',
          name: 'platformintroduction',
          component:() => import('@/view/PlatformIntroduction'),
          meta: {
            title: '平台介绍'
          }
        },{
          path: '/contactus',
          name: 'contactus',
          component:() => import('@/view/ContactUs'),
          meta: {
            title: '联系我们'
          }
        },{
          path: '/complaintAndfeedback',
          name: 'complaintAndfeedback',
          component:() => import('@/view/ComplaintAndFeedback'),
          meta: {
            title: '反馈与投诉'
          }
        },
        {
          path:'/portalzone',
          name:'portalzone',
          component:() => import('@/view/PortalZone'),
          meta: {
            title: '门户专区'
          }
        },
        {
          path:'/agencyinfo',
          name:'agencyinfo',
          component:() => import('@/view/AgencyInfo'),
          meta: {
            title: '招标代理信息'
          }
        },
        {
          path:'/supplierinfo',
          name:'supplierinfo',
          component:() => import('@/view/SupplierInfo'),
          meta: {
            title: '招标代理信息'
          }
        },
        {
          path:'/DemoHomePage',
          name:'DemoHomePage',
          component:() => import('@/view/PortalZone/Demo/HomePage'),
          meta: {
            title: '门户专区-国兴资本'
          }
        },
        {
          path:'/TJBankHomePage',
          name:'TJBankHomePage',
          component:() => import('@/view/PortalZone/TJBankPortal/HomePage'),
          meta: {
            title: '门户专区-天津银行'
          }
        },
        {
          path:'/TJBankNews',
          name:'TJBankNews',
          component:() => import('@/view/PortalZone/TJBankPortal/Headnav/News')  ,
          meta: {
            title: '门户专区新闻'
          }
        },
        {
          path:'/DemoNewsdetails',
          name:'DemoNewsdetails',
          component:() => import('@/view/PortalZone/Demo/Headnav/Newsdetails')  ,
          meta: {
            title: '门户专区新闻详情'
          }
        },
        {
          path:'/DemoNews',
          name:'DemoNews',
          component:() => import('@/view/PortalZone/Demo/Headnav/News')  ,
          meta: {
            title: '门户专区新闻'
          }
        },
        {
          path:'/DemoBoffing',
          name:'DemoBoffing',
          component:() => import('@/view/PortalZone/Demo/boffinghall/Boffing')  ,
          meta: {
            title: '采购信息'
          }
        },
        {
          path:'/NJSHomePage',
          name:'NJSHomePage',
          component:() => import('@/view/PortalZone/NJSPortal/HomePage'),
          meta: {
            title: '门户专区-天津银行'
          }
        },
        {
          path:'/NJSNews',
          name:'NJSNews',
          component:() => import('@/view/PortalZone/NJSPortal/Headnav/News')  ,
          meta: {
            title: '门户专区新闻'
          }
        },
      ]
    },
    {
      path:'/DemoHomePage',
      name:'DemoHomePage',
      redirect: '/policieslaw/nationalpolicy',
      component:() => import('@/view/PortalZone/Demo/HomePage'),
      children:[
        {
          path: '/policieslaw/nationalpolicy',
          name: 'DemoHomePage',
          component:() => import('@/view/NationalPolicy'),
          meta: {
            title: '门户专区首页'
          }
        }, {
          path: '/policieslaw/localpolicy',
          name: 'localpolicy',
          component:() => import('@/view/LocalPolicy'),
          meta: {
            title: '地方相关政策'
          }
        },
        {
          path: '/policieslaw/platformpolicy',
          name: 'platformpolicy',
          component:() => import('@/view/PlatformPolicy'),
          meta: {
            title: '平台制度'
          }
        },
      ]
    },
  ]

})



// WEBPACK FOOTER //
// ./src/router/index.js